import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 *  Gradient Overlay adds a gradient overlay to a wrapper or over a child component
 */
function GradientOverlay(_ref) {
  let {
    className,
    direction = 'top-to-bottom',
    uiContext = 'dark',
    children,
    ...rest
  } = _ref;
  const rootClassName = clsx({
    'gradient-overlay': true
  }, direction, uiContext, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "gradientOverlay",
    className: rootClassName
  }, rest), children);
}
export default GradientOverlay;